import React from 'react';
import { BRAND_LIBRARY_LIGHT_TEXT_COLOR } from 'common/constants/brandLibrary';
import Block from './SessionsBlock.styles';

export default function SessionsBlock(props) {
    return <Block {...props} />;
}

SessionsBlock.splash = {
    ...Block.splash,
    defaultProps: {
        ...Block.splash.defaultProps,
        styles: {
            ...Block.splash.defaultProps.styles,
            backgroundColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
        },
    },
};
